// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activity-logs-container {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.activity-logs-container h1 {
  font-size: 2rem;
  color: #e0e0e0;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filters-container {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.search-form {
  margin-bottom: 1.5rem;
}

.search-input-group {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.search-input-group:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon {
  color: #9ca3af;
  margin-right: 0.75rem;
}

.search-input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #e0e0e0;
  font-size: 1rem;
  outline: none;
}

.search-input::placeholder {
  color: #6b7280;
}

.search-button {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 1rem;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.filter-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.filter-group label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #9ca3af;
  font-size: 0.875rem;
  font-weight: 500;
}

.filter-icon {
  color: #6b7280;
  font-size: 0.875rem;
}

.filter-select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e0e0e0;
  padding: 0.5rem;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-select option {
  background: #1a1a1a;
  color: #e0e0e0;
}

.logs-info {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border-radius: 8px;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logs-info p {
  color: #9ca3af;
  margin: 0;
}

.logs-info strong {
  color: #3b82f6;
  font-size: 1.125rem;
}

.loading,
.no-logs {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border-radius: 12px;
  padding: 3rem;
  text-align: center;
  color: #9ca3af;
  font-size: 1.125rem;
}

.logs-table-container {
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
}

.logs-table thead {
  background: rgba(0, 0, 0, 0.3);
}

.logs-table th {
  color: #9ca3af;
  font-weight: 600;
  text-align: left;
  padding: 1rem;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logs-table tbody tr {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: background-color 0.2s ease;
}

.logs-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.03);
}

.logs-table td {
  padding: 1rem;
  color: #e0e0e0;
  font-size: 0.875rem;
}

.timestamp {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #9ca3af;
  font-size: 0.813rem;
  white-space: nowrap;
}

.time-icon {
  color: #6b7280;
  font-size: 0.75rem;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.user-icon {
  color: #8b5cf6;
  font-size: 0.875rem;
}

.action-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.entity-type {
  color: #3b82f6;
  font-weight: 500;
  font-size: 0.875rem;
}

.details {
  max-width: 300px;
}

.detail-item {
  display: flex;
  gap: 0.5rem;
  font-size: 0.813rem;
  color: #9ca3af;
  margin-bottom: 0.25rem;
}

.detail-key {
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  color: #d1d5db;
}

.ip-address {
  color: #6b7280;
  font-family: 'Courier New', monospace;
  font-size: 0.813rem;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding: 1rem;
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border-radius: 8px;
}

.pagination-button {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #4b5563;
}

.page-info {
  color: #9ca3af;
  font-weight: 500;
}

@media (max-width: 768px) {
  .activity-logs-container {
    padding: 1rem;
  }

  .filter-row {
    grid-template-columns: 1fr;
  }

  .logs-table-container {
    overflow-x: auto;
  }

  .logs-table {
    min-width: 700px;
  }

  .detail-item {
    flex-direction: column;
    gap: 0.125rem;
  }
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .activity-logs-container h1 {
  color: #1e293b;
}

[data-theme="light"] .filters-container {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .search-input-group {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .search-input-group:focus-within {
  border-color: #64748b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.1);
}

[data-theme="light"] .search-icon {
  color: #64748b;
}

[data-theme="light"] .search-input {
  color: #1e293b;
}

[data-theme="light"] .search-input::placeholder {
  color: #94a3b8;
}

[data-theme="light"] .filter-group label {
  color: #475569;
}

[data-theme="light"] .filter-icon {
  color: #64748b;
}

[data-theme="light"] .filter-select {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.15);
  color: #1e293b;
}

[data-theme="light"] .filter-select:focus {
  border-color: #64748b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.1);
}

[data-theme="light"] .filter-select option {
  background: #ffffff;
  color: #1e293b;
}

[data-theme="light"] .logs-info {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .logs-info p {
  color: #475569;
}

[data-theme="light"] .logs-info strong {
  color: #64748b;
}

[data-theme="light"] .loading,
[data-theme="light"] .no-logs {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #475569;
}

[data-theme="light"] .logs-table-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .logs-table thead {
  background: rgba(15, 23, 42, 0.05);
}

[data-theme="light"] .logs-table th {
  color: #475569;
  border-bottom: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .logs-table tbody tr {
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

[data-theme="light"] .logs-table tbody tr:hover {
  background: rgba(100, 116, 139, 0.05);
}

[data-theme="light"] .logs-table td {
  color: #1e293b;
}

[data-theme="light"] .timestamp {
  color: #64748b;
}

[data-theme="light"] .time-icon {
  color: #94a3b8;
}

[data-theme="light"] .user-icon {
  color: #8b5cf6;
}

[data-theme="light"] .entity-type {
  color: #3b82f6;
}

[data-theme="light"] .detail-item {
  color: #64748b;
}

[data-theme="light"] .detail-key {
  color: #475569;
}

[data-theme="light"] .detail-value {
  color: #1e293b;
}

[data-theme="light"] .ip-address {
  color: #64748b;
}

[data-theme="light"] .pagination {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .pagination-button:disabled {
  background: #cbd5e1;
}

[data-theme="light"] .page-info {
  color: #475569;
}`, "",{"version":3,"sources":["webpack://./src/features/activity-logging/ActivityLogs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".activity-logs-container {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.activity-logs-container h1 {\n  font-size: 2rem;\n  color: #e0e0e0;\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.filters-container {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.search-form {\n  margin-bottom: 1.5rem;\n}\n\n.search-input-group {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  padding: 0.5rem 1rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: all 0.3s ease;\n}\n\n.search-input-group:focus-within {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.search-icon {\n  color: #9ca3af;\n  margin-right: 0.75rem;\n}\n\n.search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #e0e0e0;\n  font-size: 1rem;\n  outline: none;\n}\n\n.search-input::placeholder {\n  color: #6b7280;\n}\n\n.search-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-left: 1rem;\n}\n\n.search-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.filter-group label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #9ca3af;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.filter-icon {\n  color: #6b7280;\n  font-size: 0.875rem;\n}\n\n.filter-select {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #e0e0e0;\n  padding: 0.5rem;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filter-select option {\n  background: #1a1a1a;\n  color: #e0e0e0;\n}\n\n.logs-info {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border-radius: 8px;\n  padding: 1rem 1.5rem;\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.logs-info p {\n  color: #9ca3af;\n  margin: 0;\n}\n\n.logs-info strong {\n  color: #3b82f6;\n  font-size: 1.125rem;\n}\n\n.loading,\n.no-logs {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border-radius: 12px;\n  padding: 3rem;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 1.125rem;\n}\n\n.logs-table-container {\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.logs-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.logs-table thead {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.logs-table th {\n  color: #9ca3af;\n  font-weight: 600;\n  text-align: left;\n  padding: 1rem;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logs-table tbody tr {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  transition: background-color 0.2s ease;\n}\n\n.logs-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.logs-table td {\n  padding: 1rem;\n  color: #e0e0e0;\n  font-size: 0.875rem;\n}\n\n.timestamp {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #9ca3af;\n  font-size: 0.813rem;\n  white-space: nowrap;\n}\n\n.time-icon {\n  color: #6b7280;\n  font-size: 0.75rem;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.user-icon {\n  color: #8b5cf6;\n  font-size: 0.875rem;\n}\n\n.action-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.entity-type {\n  color: #3b82f6;\n  font-weight: 500;\n  font-size: 0.875rem;\n}\n\n.details {\n  max-width: 300px;\n}\n\n.detail-item {\n  display: flex;\n  gap: 0.5rem;\n  font-size: 0.813rem;\n  color: #9ca3af;\n  margin-bottom: 0.25rem;\n}\n\n.detail-key {\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.detail-value {\n  color: #d1d5db;\n}\n\n.ip-address {\n  color: #6b7280;\n  font-family: 'Courier New', monospace;\n  font-size: 0.813rem;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding: 1rem;\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n  border-radius: 8px;\n}\n\n.pagination-button {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.pagination-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #4b5563;\n}\n\n.page-info {\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .activity-logs-container {\n    padding: 1rem;\n  }\n\n  .filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .logs-table-container {\n    overflow-x: auto;\n  }\n\n  .logs-table {\n    min-width: 700px;\n  }\n\n  .detail-item {\n    flex-direction: column;\n    gap: 0.125rem;\n  }\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .activity-logs-container h1 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .filters-container {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .search-input-group {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .search-input-group:focus-within {\n  border-color: #64748b;\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.1);\n}\n\n[data-theme=\"light\"] .search-icon {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .search-input {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .search-input::placeholder {\n  color: #94a3b8;\n}\n\n[data-theme=\"light\"] .filter-group label {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .filter-icon {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .filter-select {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.15);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .filter-select:focus {\n  border-color: #64748b;\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.1);\n}\n\n[data-theme=\"light\"] .filter-select option {\n  background: #ffffff;\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .logs-info {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .logs-info p {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .logs-info strong {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .loading,\n[data-theme=\"light\"] .no-logs {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #475569;\n}\n\n[data-theme=\"light\"] .logs-table-container {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .logs-table thead {\n  background: rgba(15, 23, 42, 0.05);\n}\n\n[data-theme=\"light\"] .logs-table th {\n  color: #475569;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .logs-table tbody tr {\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n[data-theme=\"light\"] .logs-table tbody tr:hover {\n  background: rgba(100, 116, 139, 0.05);\n}\n\n[data-theme=\"light\"] .logs-table td {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .timestamp {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .time-icon {\n  color: #94a3b8;\n}\n\n[data-theme=\"light\"] .user-icon {\n  color: #8b5cf6;\n}\n\n[data-theme=\"light\"] .entity-type {\n  color: #3b82f6;\n}\n\n[data-theme=\"light\"] .detail-item {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .detail-key {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .detail-value {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .ip-address {\n  color: #64748b;\n}\n\n[data-theme=\"light\"] .pagination {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .pagination-button:disabled {\n  background: #cbd5e1;\n}\n\n[data-theme=\"light\"] .page-info {\n  color: #475569;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
